Auth = require 'db/auth'
React = require 'react'
t = require('views/internal/recup-with-helpers')('in-app-notif')
trackUe = require 'debug/trackUe'
_ = require 'underscore'
$ = require 'jquery'
Promise = require 'bluebird'

module.exports = class InAppNotifComponent extends React.Component
  displayName: 'HeaderNotifications'

  constructor: ->
    this.state =
      visible: true

  render: t.renderable ->
    onClick = => @submitAndDismiss(true)
    atlassianTosUrl = 'https://www.atlassian.com/legal/cloud-terms-of-service'
    summaryOfChangesUrl = 'https://help.trello.com/article/1125-cloud-terms-of-service-summary-of-changes'

    if !@state.visible
      return t.div()

    t.div '.notice-of-tos-change-container', ->

      t.h2 '.notice-of-tos-change-title', ->
        t.format 'terms-of-service-update'

      t.p '.notice-of-replacement', ->
        t.format 'weve-replaced-the-trello-terms-of-service',
          { atlassianTosUrl, summaryOfChangesUrl }

      t.p '.explanation-of-agreement', ->
        t.format 'by-clicking-i-agree'

      t.div '.agree-to-tos-button', ->
        t.button '.button.primary', { onClick: onClick },
          -> t.format 'i-agree'

  submitAndDismiss: ->
    Auth.me().agreeToAndDismissTosChange()
    trackUe(
      'notifications menu:',
      'accepts',
      'terms of service',
      'for the nov 1 alert',
      'by clicking the button')
    @setState(visible: false)



// WEBPACK FOOTER //
// ./app/scripts/views/in-app-notif/notice-of-tos-change.coffee